.showOnlyFilter {
    display: flex;
    align-items: center;
    gap: var(--bi-scale-2x);

    > p {
        font: var(--bi-font-body-large);
        min-width: fit-content;
    }
}

.chipsContainer {
    display: flex;
    align-items: center;
    gap: var(--bi-scale-2x);
    overflow-x: auto;
    padding: var(--bi-scale-1-5x);
}

.filterChip {
    flex-shrink: 0;
}
